import React from 'react';

import { useTranslation } from 'react-i18next';

import FullscreenIcon from 'assets/images/svgs/Player/ico_fullscreen.svg';
import ExitFullscreenIcon from 'assets/images/svgs/Player/ico_fullscreen_reverse.svg';

import { LANGUAGE_KEYS } from 'config/languageKeys';
import {
    PLAYER_EXIT_FULL_SCREEN_ICON,
    PLAYER_FULL_SCREEN_ICON,
} from 'config/testID';

import SvgButton from 'components/CustomButtons/SvgButton';

import styles from './styles';

type Props = {
    fullscreen: boolean;
    onFullscreenPress(): void;
    onMinimizePress(): void;
};

const {
    ACCESSIBILITY: {
        PLAYER: {
            ACCESSIBILITY_PLAYER_MAXIMIZE,
            ACCESSIBILITY_PLAYER_MINIMIZE,
        },
    },
} = LANGUAGE_KEYS;

function WebFullscreenControls({
    fullscreen,
    onFullscreenPress,
    onMinimizePress,
}: Props) {
    const { t } = useTranslation();

    return fullscreen ? (
        <SvgButton
            accessibilityRole="button"
            accessibilityLabel={t(ACCESSIBILITY_PLAYER_MINIMIZE)}
            style={styles.fullscreenButton}
            Svg={ExitFullscreenIcon}
            onPress={onMinimizePress}
            testID={PLAYER_EXIT_FULL_SCREEN_ICON}
        />
    ) : (
        <SvgButton
            accessibilityRole="button"
            accessibilityLabel={t(ACCESSIBILITY_PLAYER_MAXIMIZE)}
            style={styles.fullscreenButton}
            Svg={FullscreenIcon}
            onPress={onFullscreenPress}
            testID={PLAYER_FULL_SCREEN_ICON}
        />
    );
}

export default WebFullscreenControls;
